export const SearchIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5487 2.89795C14.6105 2.89795 17.904 6.19059 17.904 10.2532C17.904 14.3158 14.6105 17.6085 10.5487 17.6085C6.48612 17.6085 3.19348 14.3158 3.19348 10.2532C3.19348 6.19059 6.48612 2.89795 10.5487 2.89795Z"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.64831 6.20312C9.25341 6.20312 8.86238 6.28091 8.49755 6.43202C8.13271 6.58314 7.80122 6.80464 7.52199 7.08388C7.24275 7.36311 7.02125 7.6946 6.87013 8.05944C6.71902 8.42427 6.64124 8.8153 6.64124 9.2102"
      stroke="#99E1FF"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17.625 17.6084L20.7128 20.6962"
      stroke="#fff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export const LocationIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.91602 8.59821C2.91602 4.76499 6.11925 1.66675 9.99389 1.66675C13.8794 1.66675 17.0827 4.76499 17.0827 8.59821C17.0827 10.5298 16.3802 12.3231 15.2239 13.8431C13.9484 15.5197 12.3761 16.9805 10.6065 18.1271C10.2014 18.3921 9.83591 18.4121 9.39139 18.1271C7.61163 16.9805 6.03942 15.5197 4.77477 13.8431C3.61767 12.3231 2.91602 10.5298 2.91602 8.59821ZM7.66121 8.81404C7.66121 10.0982 8.70906 11.1081 9.99389 11.1081C11.2796 11.1081 12.3375 10.0982 12.3375 8.81404C12.3375 7.53991 11.2796 6.48077 9.99389 6.48077C8.70906 6.48077 7.66121 7.53991 7.66121 8.81404Z"
      fill="#4A50FF"
    />
  </svg>
)
export const PhoneIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0159 4.57512C11.6192 4.50184 11.2548 4.755 11.1793 5.14224C11.1038 5.52947 11.3577 5.90754 11.7437 5.98332C12.9055 6.20984 13.8027 7.10922 14.0301 8.27508V8.27592C14.0948 8.61152 14.3903 8.85552 14.7305 8.85552C14.7762 8.85552 14.8218 8.85136 14.8683 8.84303C15.2542 8.76558 15.5082 8.38834 15.4326 8.00027C15.0932 6.25897 13.7529 4.91406 12.0159 4.57512Z"
      fill="#4A50FF"
    />
    <path
      d="M11.9645 1.67336C11.7786 1.64671 11.5919 1.70167 11.4433 1.81992C11.2906 1.93984 11.1952 2.11305 11.1744 2.30709C11.1304 2.69932 11.4134 3.05407 11.8052 3.09821C14.5065 3.39967 16.6062 5.50406 16.91 8.21386C16.9507 8.57695 17.2552 8.85093 17.6187 8.85093C17.6461 8.85093 17.6727 8.84926 17.7001 8.84593C17.8901 8.82511 18.0594 8.73101 18.1789 8.58111C18.2976 8.43121 18.3516 8.24468 18.33 8.05397C17.9515 4.67296 15.3348 2.04893 11.9645 1.67336Z"
      fill="#4A50FF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.19247 10.8103C12.5167 14.1336 13.2708 10.2889 15.3874 12.404C17.4279 14.444 18.6007 14.8527 16.0154 17.4373C15.6915 17.6975 13.634 20.8286 6.40318 13.5997C-0.82855 6.37 2.30067 4.31037 2.56099 3.98662C5.15257 1.39487 5.55423 2.57449 7.59476 4.61444C9.71132 6.73041 5.86823 7.48701 9.19247 10.8103Z"
      fill="#4A50FF"
    />
  </svg>
)
export const EmailIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.02612 2.86802C4.75566 3.37111 2.96569 5.11653 2.40515 7.37396C1.97693 9.09846 1.97693 10.9015 2.40514 12.626C2.96569 14.8835 4.75566 16.6289 7.02611 17.132L7.40434 17.2158C9.11448 17.5947 10.8868 17.5947 12.597 17.2158L12.9752 17.132C15.2456 16.6289 17.0356 14.8835 17.5962 12.626C18.0244 10.9015 18.0244 9.09846 17.5962 7.37396C17.0356 5.11653 15.2456 3.37111 12.9752 2.86802L12.597 2.78421C10.8868 2.40526 9.11449 2.40526 7.40434 2.78421L7.02612 2.86802ZM7.11286 8.1776C6.86576 8.00105 6.52236 8.0583 6.34586 8.30546C6.16935 8.55262 6.22659 8.8961 6.47369 9.07264L8.61579 10.603C9.44423 11.1949 10.5571 11.1949 11.3855 10.603L13.5277 9.07264C13.7748 8.8961 13.832 8.55262 13.6555 8.30546C13.479 8.0583 13.1356 8.00105 12.8885 8.1776L10.7464 9.70801C10.3003 10.0267 9.70105 10.0267 9.25497 9.70801L7.11286 8.1776Z"
      fill="#4A50FF"
    />
  </svg>
)
